// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container carousel {
  z-index: 1;
}
.main-container mat-divider {
  margin-bottom: 2rem;
}
.main-container mat-divider:first-of-type {
  margin: 2rem 0;
}
.main-container p {
  text-align: justify;
  margin-bottom: 2rem;
  color: var(--text-color);
}
.main-container h1 {
  font-size: 250%;
  text-align: center;
  color: var(--text-color);
}
.main-container img {
  width: 100%;
  border-radius: 5px;
}
.main-container ::ng-deep .carousel-container {
  border-radius: 5px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/history/history.component.scss"],"names":[],"mappings":"AACE;EACE,UAAA;AAAJ;AAGE;EACE,mBAAA;AADJ;AAGI;EACE,cAAA;AADN;AAKE;EACE,mBAAA;EACA,mBAAA;EACA,wBAAA;AAHJ;AAME;EACE,eAAA;EACA,kBAAA;EACA,wBAAA;AAJJ;AAOE;EACE,WAAA;EACA,kBAAA;AALJ;AAQE;EACE,6BAAA;AANJ","sourcesContent":[".main-container {\r\n  carousel {\r\n    z-index: 1;\r\n  }\r\n\r\n  mat-divider {\r\n    margin-bottom: 2rem;\r\n\r\n    &:first-of-type {\r\n      margin: 2rem 0;\r\n    }\r\n  }\r\n\r\n  p {\r\n    text-align: justify;\r\n    margin-bottom: 2rem;\r\n    color: var(--text-color);\r\n  }\r\n\r\n  h1 {\r\n    font-size: 250%;\r\n    text-align: center;\r\n    color: var(--text-color);\r\n  }\r\n\r\n  img {\r\n    width: 100%;\r\n    border-radius: 5px;\r\n  }\r\n\r\n  ::ng-deep .carousel-container {\r\n    border-radius: 5px !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
